import React from "react";
import PropTypes from "prop-types";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import Switch from "Common/Custom/Switch";

/**
 * AddLaundryProductForm — pure presentational component.
 *
 * Field behaviour:
 *  - product_name      → select from products_list
 *  - in_laundry_quantity → editable; triggers ready_quantity recalculation in parent
 *  - ready_quantity    → disabled; auto-set to (available - in_laundry)
 *  - total_quantity    → disabled; auto-set to (in_laundry + ready)
 *  - category_type     → select from static options
 *  - status            → switch
 */
const AddLaundryProductForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  fields,
  productOptions = [],
}) => {


  const renderField = (field) => {
    // product_name — populated from products_list
    if (field.name === "product_name" && field.type === "select") {
      return (
        <FormSelect
          key={field.name}
          field={field}
          value={values[field.name] ?? ""}
          handleChange={handleChange}
          options={productOptions}
          error={errors[field.name]}
        />
      );
    }

    if (field.type === "switch") {
      return (
        <Switch
          key={field.name}
          field={field}
          values={values[field.name]}
          handleChange={handleChange}
          error={errors[field.name]}
          ValueOne="1"
          ValueTwo="0"
          LabelOne="Active"
          LabelTwo="Inactive"
        />
      );
    }

    if (field.type === "select") {
      return (
        <FormSelect
          key={field.name}
          field={field}
          value={values[field.name] ?? ""}
          handleChange={handleChange}
          options={field.options || []}
          error={errors[field.name]}
        />
      );
    }

    return (
      <FormInput
        key={field.name}
        field={field}
        value={values[field.name] ?? ""}
        handleChange={handleChange}
        error={errors[field.name]}
      />
    );
  };

  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>Add Laundry Items</HeadingOne>}
    >
      {fields.map(renderField)}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

AddLaundryProductForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  fields: PropTypes.array.isRequired,
  productOptions: PropTypes.array,
};

AddLaundryProductForm.defaultProps = {
  errors: {},
  loading: false,
  productOptions: [],
};

export default AddLaundryProductForm;
